import styled from 'styled-components/macro'
import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

export const SummarySaleCodeBox = styled(Box)`
    * {
        white-space: nowrap;
    }
    a:focus {
        color: ${({ theme }) => theme.colors.grayscale_400};
    }
    a:visited {
        color: ${({ theme }) => theme.colors.grayscale_400};
    }
    @media ${respondAbove.xl} {
        ${Text} + ${Text} {
            display: inline;
        }
    }
`

export const SummarySaleCodeButton = styled.button`
    height: auto;
    width: auto;
`

export const SummarySaleCodeContent = styled(Box)`
    max-height: 20px;
`
